export interface CampaignCreationMethodItemStylePalette {
  white?: string;
  neutralPrimary?: string;
  red?: string;
}

export const getCampaignCreationMethodItemStyles = (
  _: unknown,
  { palette = {} }: { palette?: CampaignCreationMethodItemStylePalette }
) => ({
  itemContainer: {
    width: 176,
    height: 197,
    background: palette.white,
    boxShadow: '0px 1.6px 3.6px rgba(0, 0, 0, 0.132), 0px 0.3px 0.9px rgba(0, 0, 0, 0.108)',
    borderRadius: 4,
    border: '1px solid #D1D1D1',
    cursor: 'pointer',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '&:hover, &:focus': {
      border: '2px solid #0078D4',
    },
  },

  verticalItemContainer: {
    width: 280,
    height: 200,
    justifyContent: 'center',
  },

  selectedItemContainer: {
    borderColor: '#0078D4',
  },

  disabledItemContainer: {
    background: '#F0F0F0',
    '&:hover, &:focus': {
      borderColor: 'transparent',
    },
  },

  imageContainerStyle: {
    width: '100%',
    paddingTop: 29,
    paddingBottom: 18,
    height: 136,
    '& img': {
      width: 'auto',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },

  verticalImageContainer: {
    paddingTop: 12,
    paddingBottom: 12,
    height: 120,
  },

  content: {
    display: 'block',
    paddingLeft: 3,
    color: palette.neutralPrimary,
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 600,
  },

  contentInTwoLines: {
    marginLeft: 25,
    marginRight: 25,
  },

  disableText: {
    color: palette.red,
    fontSize: 12,
    marginTop: 8,
    maxWidth: 140,
  },
});

export const CampaignCreationMethodSelectionStyles = {
  itemContainerTokens: {
    childrenGap: '24px',
  },
  itemContainerVerticalTokens: {
    childrenGap: '16px',
  },
};
